import { css } from "@emotion/core";
import styled from "@emotion/styled";
import Skeleton from "react-loading-skeleton";
import { NectarTheme } from "../../../../typings/theme";

export const CounterSkeleton = styled(Skeleton)`
  ${({ _theme }: NectarTheme) => css`
    height: 57px;
  `}
`;

export const CounterWithComparisonSkeleton = styled(Skeleton)`
  ${({ _theme }: NectarTheme) => css`
    height: 162px;
    width: 202px;
  `}
`;

export const RadarChartSkeleton = styled(Skeleton)`
  ${({ _theme }: NectarTheme) => css`
    height: 365px;
    width: 100%;
  `}
`;

export const SkeletonContainer = styled.div`
  ${({ customGap, theme }: { customGap?: string; theme: NectarTheme["theme"] }) => css`
    gap: ${customGap ?? `${theme.spacings.lg} 0px`};
    display: flex;
    flex-direction: column;
    & span {
      flex-grow: 1;
    }
  `}
`;

export const LawsuitUpdateCounterSkeletonWrapper = styled.div`
  ${({ theme }: NectarTheme) => css`
    display: flex;
    flex-direction: row;
    column-gap: ${theme.spacings.lg};

    & span {
      flex-grow: 1;
    }
  `}
`;
